/**
 * @generated SignedSource<<1b0f696a99acdc032c896617bbc53dd4>>
 * @relayHash 1fe65c7f850b0fd2bffbacc6bcd46807
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ea40ca8b1863c0995446437f03f59347faee0237ea0100149114208fb0ac90bc

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type uiFieldsPageQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type uiFieldsPageQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly isExplicitFieldAssociationsEnabled: boolean | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"pageHeader_projectFields_Header">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"fieldsTable_projectFields">;
};
export type uiFieldsPageQuery = {
  response: uiFieldsPageQuery$data;
  variables: uiFieldsPageQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcisprojectfieldsgafastfollowsgateenabledrelayprovider": isProjectFieldsGaFastFollowsEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisprojectfieldsgafastfollowsgateenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isProjectFieldsGaFastFollowsEnabled_provider from '@atlassian/jira-relay-provider/src/is-project-fields-ga-fast-follows-gate-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "isExplicitFieldAssociationsEnabled"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "key"
},
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiFieldsPageQuery",
    "selections": [
      {
        "args": [
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
          }
        ],
        "kind": "FragmentSpread",
        "name": "fieldsTable_projectFields"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "pageHeader_projectFields_Header"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisprojectfieldsgafastfollowsgateenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "uiFieldsPageQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "ScalarField",
                "name": "projectId"
              },
              {
                "kind": "ScalarField",
                "name": "projectType"
              },
              {
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "issueTypes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v8/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v9/*: any*/),
              {
                "kind": "ScalarField",
                "name": "optionsPerFieldLimit"
              },
              {
                "concreteType": "JiraFieldTypeGroupConnection",
                "kind": "LinkedField",
                "name": "projectFieldTypeGroups",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFieldTypeGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFieldTypeGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "displayName"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "JiraProjectWithIssueTypeIds",
                "kind": "LinkedField",
                "name": "projectWithVisibleIssueTypeIds",
                "plural": false,
                "selections": [
                  {
                    "args": (v10/*: any*/),
                    "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                    "kind": "LinkedField",
                    "name": "fieldAssociationWithIssueTypes",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraFieldAssociationWithIssueTypes",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "concreteType": "JiraField",
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "fieldId"
                                  },
                                  (v8/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "scope"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "typeName"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "description"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "typeKey"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "hasMissingConfiguration"
                              },
                              {
                                "concreteType": "JiraIssueTypeConnection",
                                "kind": "LinkedField",
                                "name": "issueTypes",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v6/*: any*/),
                                          (v8/*: any*/),
                                          (v7/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "JiraFieldOperation",
                                "kind": "LinkedField",
                                "name": "fieldOperation",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canRemove"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canDelete"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canAssociateInSettings"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canEdit"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canModifyOptions"
                                  }
                                ]
                              },
                              {
                                "concreteType": "JiraFieldOptionConnection",
                                "kind": "LinkedField",
                                "name": "fieldOptions",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraFieldOptionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraFieldOption",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "optionId"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "parentOptionId"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "value"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isFieldLocked"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          }
                        ]
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      }
                    ],
                    "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                  },
                  {
                    "args": (v10/*: any*/),
                    "filters": [
                      "input"
                    ],
                    "handle": "connection",
                    "key": "fieldsTable_fieldAssociationWithIssueTypes",
                    "kind": "LinkedHandle",
                    "name": "fieldAssociationWithIssueTypes"
                  }
                ]
              },
              (v8/*: any*/),
              (v4/*: any*/),
              {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisprojectfieldsgafastfollowsgateenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "projectScopedFieldsPerProjectLimit"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "projectScopedFieldsCount"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ea40ca8b1863c0995446437f03f59347faee0237ea0100149114208fb0ac90bc",
    "metadata": {},
    "name": "uiFieldsPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisprojectfieldsgafastfollowsgateenabledrelayprovider": isProjectFieldsGaFastFollowsEnabled_provider
    }
  }
};
})();

(node as any).hash = "b0872e3059548632993c06522c7f5584";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
